// extracted by mini-css-extract-plugin
module.exports = {"ways":"waysToBid-module--ways--jC2lu","waysText":"waysToBid-module--waysText--3pS5w"};